// extracted by mini-css-extract-plugin
export default {"-large":"FvjNrK6tK483JwwWScK4","addAccount":"_Tt7mrONmFLJG5tww8S7"};